import * as React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio, { type RadioProps as MuiRadioProps } from '@mui/material/Radio';

export interface RadioButtonProps extends Omit<MuiRadioProps, 'onChange'> {
  /** react-toolbox: label text */
  label?: React.ReactNode;
  /** react-toolbox: value of the radio button */
  value?: string;
  /** react-toolbox: callback with value when changed */
  onChange?: (value: string, event: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * RadioButton wrapper - maps react-toolbox RadioButton to MUI Radio + FormControlLabel
 * - `label` wraps Radio in FormControlLabel
 * - `onChange(value)` transformed from MUI's `onChange(event)`
 */
const RadioButton = React.forwardRef<HTMLButtonElement, RadioButtonProps>(
  ({ label, value, onChange, ...rest }, ref) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(event.target.value, event);
      }
    };

    const radio = <Radio ref={ref} value={value} onChange={handleChange} {...rest} />;

    if (label) {
      return <FormControlLabel control={radio} label={label} />;
    }

    return radio;
  },
);

RadioButton.displayName = 'RadioButton';

export default RadioButton;
